import React, { FC, useEffect, useState } from 'react'
import { Draggable } from 'atoms/Draggable'
import Icon from 'blocks.simple/icon/icon'
import { cn } from 'ethcss'
import { styles } from './DownloadProgressModal-styles'
import { grid, item, layers } from 'theme'
import translate from 'core/translate'
import { Typography } from 'atoms/Typography'
import { getThemeStyleValue } from 'theme/colors'
import { defaultThemeStyles } from './DownloadProgressModal.theme'
import Searchbar from 'blocks.app/searchbar/searchbar'
import { BroadcastItemView } from '../../atoms/BroadcastItem/BroadcastItem-view'
import { AdvertisementItemView } from '../../atoms/AdvertisementItem/AdvertisementItem-view'
import { api } from '../../../../../../core/api/ConnectionManager'
import { IDownloadModalPosition } from '../../../../../../core/services/DownloadService/DownloadService-types'
import { DropdownSelect } from '../../../../../instancesCatalog/_lensOfTime/InstancesCatalogLensOfTimeViewModules'

export interface IDownloadModalProps {
    closeModal: () => void
    setPosition: (pos: IDownloadModalPosition) => void
    position: IDownloadModalPosition
    handleClose: any
    digitalSignageId: number | null
}

export const DownloadModal: FC<IDownloadModalProps> = ({
    closeModal,
    setPosition,
    position,
    handleClose,
    digitalSignageId,
}) => {
    const [receivedItems, setReceivedItems] = useState<any[]>([])
    const [searchKeyWord, setSearchKeyWord] = useState('')
    const [downloadList, setDownloadList] = useState<any[]>([])
    const [updateTimeout, setUpdateTimeout] = useState(10 * 1000)
    const [updateKey, setUpdateKey] = useState('')
    let timer: any = null
    const listenersId: string[] = []

    const getBroadcastList = () => {
        if (!digitalSignageId) return

        api.send('requestBroadcastInfo', {
            digitalSignageId,
        })
    }

    const getItemId = (item: any) => (item.type === 'broadcast' ? item.broadcastId : item.advertisementId)

    const isOpenedCheck = (item: any, list: any[]) => {
        for (let i = 0; i < list.length; i++) {
            if (list[i].type === item.type && getItemId(list[i]) === getItemId(item)) {
                if (list[i].isOpened) return true
            }
        }
        return false
    }

    const updateDownloadList = (incoming: any[], currentList: any[]) => {
        setDownloadList(
            incoming.map((item: any) => ({
                ...item,
                isOpened: isOpenedCheck(item, currentList),
            }))
        )
    }

    const handleItemClick = (type: 'broadcast' | 'advertisement', id: number) => {
        setDownloadList(
            downloadList.map((item: any) => {
                const itemId = getItemId(item)
                if (item.type === type && itemId === id) {
                    return { ...item, isOpened: !item.isOpened }
                }
                return { ...item, isOpened: false }
            })
        )
    }

    const searchInList = (inputKeyWord: string) => {
        setSearchKeyWord(inputKeyWord)
    }

    const getFilteredList = () => {
        return downloadList.filter((item: any) => item.name.toLowerCase().includes(searchKeyWord.toLowerCase()))
    }

    useEffect(() => {
        getBroadcastList()

        api.addObserver(
            'broadcastInfoSent',
            (data: any) => {
                if (!data) return

                if (data.digitalSignageId === digitalSignageId) {
                    const broadcasts = (data.broadcasts ?? []).map((b: any) => ({ ...b, type: 'broadcast' }))
                    const advertisements = (data.advertisements ?? []).map((a: any) => ({
                        ...a,
                        type: 'advertisement',
                    }))
                    setReceivedItems([...broadcasts, ...advertisements])
                }
            },
            listenersId
        )

        return () => {
            listenersId.forEach((id) => api.removeObserver(id))
        }
    }, [])

    useEffect(() => {
        updateDownloadList(receivedItems, downloadList)
    }, [receivedItems])

    useEffect(() => {
        clearInterval(timer)

        timer = setInterval(() => {
            setUpdateKey(Math.random().toString())
        }, updateTimeout)

        return () => {
            clearInterval(timer)
        }
    }, [updateTimeout])

    useEffect(() => {
        if (!updateKey) return
        getBroadcastList()
    }, [updateKey])

    return (
        <Draggable
            key={'downloadsModal'}
            parentRect={{
                width: window.innerWidth,
                height: window.innerHeight,
                top: 0,
                left: 0,
            }}
            isFixed
            classNames={cn(styles.downloadModal__wrapper)}
            left={position.left}
            top={position.top}
            width={position.width}
            height={position.height}
            zIndex={layers.progress}
            resizableZIndex={layers.progress}
            isRenderResizeElements={false}
            borderColor={getThemeStyleValue('app', 'downloads', 'wrapperBorder') || defaultThemeStyles.wrapperBorder}
            activeBorderColor={
                getThemeStyleValue('app', 'downloads', 'wrapperBorder') || defaultThemeStyles.wrapperBorder
            }
            onDragEnd={setPosition}
            onResizeEnd={setPosition}
            minWidth={0.2}
            minHeight={0.2}
        >
            <div className={styles.downloadModal__contentWrapper}>
                <div className={styles.downloadModal__header}>
                    <div className={item.ellipsis}>{translate('downloadsList')}</div>
                    <div className={cn(grid.row, grid.noWrap)}>
                        <div onClick={handleClose} onMouseDown={(e) => e.stopPropagation()}>
                            <Icon type={'close_tiny'} color={'white'} size={18} />
                        </div>
                    </div>
                </div>
                <div className={styles.downloadModal__contentSearchWrapper}>
                    <Searchbar className={styles.downloadModal__search} mod={'withBorder'} onChange={searchInList} />
                    <div className={styles.navWrapper}>
                        <div className={styles.downloadModal__leftBlock}>
                            <Typography className={styles.downloadModal__updateText}>
                                {translate('updateData')}
                            </Typography>
                            <DropdownSelect
                                id={null}
                                value={'10'}
                                callbackValue={null}
                                options={[
                                    { name: '5 ' + translate('seconds'), id: '5' },
                                    { name: '10 ' + translate('seconds'), id: '10' },
                                    { name: '15 ' + translate('seconds'), id: '15' },
                                    { name: '30 ' + translate('seconds'), id: '30' },
                                    { name: '60 ' + translate('seconds'), id: '60' },
                                ]}
                                onChange={(selectedValue: any) => {
                                    setUpdateTimeout(selectedValue.id * 1000)
                                }}
                            />
                        </div>
                        {/*<div className={styles.downloadModal__downloadActions}>*/}
                        {/*    <Typography>Отменить загрузку</Typography>*/}
                        {/*</div>*/}
                    </div>
                    <div className={styles.downloadModal__content}>
                        <div className={styles.downloadModal__title}>
                            <div className={styles.downloadModal__nameWrapper}>
                                <Typography className={styles.downloadModal__name}>{translate('name')}</Typography>
                            </div>
                            <div className={styles.downloadModal__progressWrapper}>
                                <Typography className={styles.downloadModal__name}>{translate('progress')}</Typography>
                            </div>
                        </div>
                        {getFilteredList().map((item: any, index: number) => {
                            if (item.type === 'advertisement') {
                                return (
                                    <AdvertisementItemView
                                        key={index}
                                        advertisementData={item}
                                        isOpened={item.isOpened}
                                        advertisementHandleClick={(id: number) => handleItemClick('advertisement', id)}
                                        digitalSignageId={digitalSignageId}
                                    />
                                )
                            }
                            return (
                                <BroadcastItemView
                                    key={index}
                                    broadcastData={item}
                                    isOpened={item.isOpened}
                                    broadcastHandleClick={(id: number) => handleItemClick('broadcast', id)}
                                    digitalSignageId={digitalSignageId}
                                />
                            )
                        })}
                    </div>
                </div>
            </div>
        </Draggable>
    )
}
